import Box from "@mui/material/Box";
import {AppBar, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar} from "@mui/material";
import {FiberNew, HomeRepairService, Menu as MenuIcon, PowerSettingsNew} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import {useState} from "react";
import database from "../../../database/database";
import {Outlet, useLocation, useNavigate} from "react-router";
import useEventDispatcher from "../../../use/useEventDispatcher";
import route from "../../../enum/route";
import Page from "../../../material/skeleton/Page";
import Header from "../../../material/skeleton/Header";
import Notification from "./Notification";
import useIdpRepository from "../../../repository/auth/useIdpRepository";

export default function () {
    const idpRepository = useIdpRepository();
    const eventDispatcher = useEventDispatcher();
    const navigate = useNavigate();
    const location = useLocation();
    const [anchorEl, setAnchorEl] = useState(null);


    const handleMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleLogout = async () => {
        database.write(database.TABLE_ROUTING, "after_auth", null);

        await idpRepository.logout();

        console.info("User logout");
        navigate(route.ROOT);
        handleClose();
    }

    const handleMyInterventions = () => {
        navigate(route.ENTREPRENEUR_INTERVENTIONS);
        handleClose();
    }

    const handleMySuggestions = () => {
        navigate(route.ENTREPRENEUR_SUGGESTIONS);
        handleClose();
    }

    const getTitle = () => {
        switch (location.pathname) {
            case route.ENTREPRENEUR_INTERVENTIONS:
                return "Interventions en cours";
            case route.ENTREPRENEUR_SUGGESTIONS:
                return "Missions proposées";
        }

        return "";
    }

    const handleTheme = theme => () => {
        eventDispatcher.launcher("toggle-mode", {
            mode: theme
        });
        handleClose();
    }


    return (
        <Page>
            <Header>
                <Box sx={{flexGrow: 1}}>
                    <AppBar position="static">
                        <Toolbar>
                            <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                                {getTitle()}
                            </Typography>
                            <div>
                                <Notification/>
                                <IconButton
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleMenu}
                                    color="inherit"
                                    data-test={"button-menu"}
                                >
                                    <MenuIcon/>
                                </IconButton>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                >
                                    {
                                        /**
                                         {
                                         !isNull(database.read(database.TABLE_THEME, "dark"))
                                         && database.read(database.TABLE_THEME, "dark") === "dark"
                                         ? <MenuItem onClick={handleTheme("light")} data-test="checkout-theme">
                                         <ListItemIcon>
                                         <LightMode/>
                                         </ListItemIcon>
                                         <ListItemText>
                                         Theme blanc
                                         </ListItemText>
                                         </MenuItem>
                                         : <MenuItem onClick={handleTheme("dark")} data-test="checkout-theme">
                                         <ListItemIcon>
                                         <DarkMode/>
                                         </ListItemIcon>
                                         <ListItemText>
                                         Theme sombre
                                         </ListItemText>
                                         </MenuItem>
                                         }

                                         */}
                                    <MenuItem onClick={handleMySuggestions} data-test="menu-suggestions">
                                        <ListItemIcon>
                                            <FiberNew/>
                                        </ListItemIcon>
                                        <ListItemText>
                                            Missions proposées
                                        </ListItemText>
                                    </MenuItem>
                                    <MenuItem onClick={handleMyInterventions} data-test="menu-interventions">
                                        <ListItemIcon>
                                            <HomeRepairService/>
                                        </ListItemIcon>
                                        <ListItemText>
                                            Interventions en cours
                                        </ListItemText>
                                    </MenuItem>
                                    <MenuItem onClick={handleLogout} data-test="menu-logout">
                                        <ListItemIcon>
                                            <PowerSettingsNew/>
                                        </ListItemIcon>
                                        <ListItemText>
                                            Déconnexion
                                        </ListItemText>
                                    </MenuItem>
                                </Menu>
                            </div>
                        </Toolbar>
                    </AppBar>
                </Box>
            </Header>
            <Outlet/>
        </Page>
    );
}